import React from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom'

// Replacement for react-router's withRouter, which v6+ removed. Class components receive
// `navigate`, `params` and `location` props so they never touch router internals directly.
export default function withNavigation(WrappedComponent) {
  function WithNavigation(props) {
    const navigate = useNavigate()
    const params = useParams()
    const location = useLocation()

    return <WrappedComponent {...props} navigate={navigate} params={params} location={location} />
  }

  const wrappedName = WrappedComponent.displayName || WrappedComponent.name || 'Component'
  WithNavigation.displayName = `withNavigation(${wrappedName})`

  return WithNavigation
}
